import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import { wrapperStyle } from './styles';
import { button, pink } from 'inside-out/global-styles';

// This is required because in the CMS we don't want to render real working links.
export class RememberPrompt extends React.Component {
	render() {
		return (
			<aside role="alert" className={wrapperStyle} data-component="RememberPrompt">
				<h1>Remember you will lose your results if you don’t save them to your profile.</h1>
				<p>If you want to remain anonymous, use an alias.</p>
				<Link className={button(pink)} to="/register">
					Create insideout profile
				</Link>
			</aside>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/rememberPrompt/component.js